import { getField, updateField } from 'vuex-map-fields'
import getDealFilterModel from './models/dealFilters'

const dealFilters = {
  namespaced: true,
  state: {
    ...getDealFilterModel()
  },
  getters: {
    getField,
    getSearchObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    clearFilters: (state) => {
      state.dealAssignmentType = null
      state.dealClientName = null
      state.consultantName = null
      state.jobTitle = null
      state.createdBy = null
      state.statusId = null
    }
  },
  actions: {
    clearFilters: ({ commit }) => {
      return commit('clearFilters')
    }
  }
}

export default dealFilters
